// Namen der fünf Stufen für Screenreader — die sichtbaren Symbole (--, -, o, +, ++)
// sagen einem Hörer nichts. Index = gespeicherter Wert 0…4.
export const ANSWER_LABELS = ['Auf keinen Fall', 'Eher nicht', 'Neutral', 'Eher ja', 'Passt total']
